import React from 'react'
import styled from '@emotion/styled'
import { colors, font } from '@mobi/component-library/Foundations'
import betLoopFlame from './assets/betloop-streak.png'

export const FlameStreakBadge = React.forwardRef<
  HTMLSpanElement,
  { value: number; className?: string }
>(({ value, className }, ref) => (
  <BadgeStyled ref={ref} style={{ backgroundImage: `url(${betLoopFlame})` }} className={className}>
    <span
      data-testid='FlameStreak'
      style={{ fontSize: value.toString().length > 2 ? '1.3rem' : undefined }}
    >
      {value}
    </span>
  </BadgeStyled>
))

FlameStreakBadge.displayName = 'FlameStreakBadge'

// ======
// Styles
// ======

const BadgeStyled = styled.span({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  height: '3.2rem',
  width: '3.2rem',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',

  '> span': {
    paddingBottom: '0.2rem',
    color: colors.white,
    textShadow:
      '0 1px 3px rgba(255, 0, 0, 0.45), -1px 1px 3.4px rgba(255, 0, 0, 0.20), 0 0 3px rgba(255, 0, 0, 0.60), 0 0 1px rgba(255, 0, 0, 0.15)',
    fontFamily: font.family.primary,
    fontStyle: 'italic',
    fontWeight: font.weight.black,
    fontSize: '1.5rem',
    lineHeight: 1,
  },
})
